import { actionTypes } from '../const';

const series = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SERIES_WORKDAY_SUCCESS:
            return Object.assign({}, state, {
                seriesworkdays: action.workdays,
                isLoading: false
            });
        case actionTypes.SERIES_IS_LOADING:
            return Object.assign({}, state, {
                seriesworkdays:[],
                isLoading : action.isLoading,
            });
        default:
            return state;
    }
}
export default series